module.exports = __webpack_public_path__ + "img/quick_release_01.2f5dea5b.png";